import { AxiosInstancePlus } from '@tencent/oneid-request';
import { http } from 'common/http';
import BaseApi from 'common/http/BaseApi';

class ContactsApi extends BaseApi {
  public axiosInstance: AxiosInstancePlus = http;

  public prefixURL = '/admin/v2';

  /** 获取明文手机号 */
  exposedMobile(params: { union_id: string }) {
    return this.axiosInstance.get(`${this.prefixURL}/contacts/users/exposed_mobile`, { params });
  }

  /** 获取明文邮箱 */
  exposedEmail(params: { union_id: string }) {
    return this.axiosInstance.get(`${this.prefixURL}/contacts/users/exposed_email`, { params });
  }
}

export default new ContactsApi();
